var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCopyHollow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1.5C2.61929 1.5 1.5 2.61929 1.5 4V8C1.5 9.38071 2.61929 10.5 4 10.5H5.5V12C5.5 13.3807 6.61929 14.5 8 14.5H12C13.3807 14.5 14.5 13.3807 14.5 12V8C14.5 6.61929 13.3807 5.5 12 5.5H10.5V4C10.5 2.61929 9.38071 1.5 8 1.5H4ZM9.5 5.5V4C9.5 3.17157 8.82843 2.5 8 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V8C2.5 8.82843 3.17157 9.5 4 9.5H5.5V8C5.5 6.61929 6.61929 5.5 8 5.5H9.5ZM6.5 8C6.5 7.17157 7.17157 6.5 8 6.5H12C12.8284 6.5 13.5 7.17157 13.5 8V12C13.5 12.8284 12.8284 13.5 12 13.5H8C7.17157 13.5 6.5 12.8284 6.5 12V8Z",
    fill: "#D1D2D3"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyHollow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy-hollow.3b0b09bfd675587eca75cf53fbca2c3b.svg";